<template>
  <div class="contract-information-page pb60" v-loading.fullscreen.lock="fullscreenLoading">
    <Title currentPageTitle="质量考核审批详情"></Title>
    <!-- 申请信息 -->
    <div class="contract-base-box" v-if="formData">
      <p class="contract-base-name">申请信息</p>
      <div class="contract-apply-box">
        <div class="contract-apply-item"><span>申请人：</span>{{ formData.staffName }}</div>
        <div class="contract-apply-item"><span>提交时间：</span>{{ formData.inputTime | getTime }}</div>
        <div class="contract-apply-item"><span>是否平台专属任务：</span>{{ formData.taskBelongCategory | categoryType }}</div>
        <!-- <div class="contract-apply-item"><span>所在部门：</span>{{ formData.organisationName }}</div> -->
      </div>
      <div class="contract-apply-box">
        <div class="contract-apply-item"><span>{{ formData.taskBelongCategory==1?'备案药企：':'所属企业：' }} </span>{{ formData.tenantName }}</div>
        <div class="contract-apply-item" v-if="formData.taskBelongCategory!=2"><span>选择部门：</span>{{ formData.organisationName }}</div>
        <div class="contract-apply-item" v-if="formData.taskBelongCategory!=2"><span>核算月：</span>{{ formData.accountMonth }}</div>
        <div class="contract-apply-item" ><span>账单周期：</span>{{ formData.billCycleList |billFilter }}</div>
        <!-- <div class="contract-apply-item"><span>任务包选择：</span>{{ formData.isPrecise == 'Y' ? '是' : '否' }}</div>
        <div class="contract-apply-item"><span>账单周期：</span>{{ formData.billCycle || '全部' }}</div> -->
      </div>
      <img v-show="formData.approveState !== 'N'" class="approve-img" :src="getApproveImg()" alt="" />
      <img  v-if="formData.isHedge=='Y'"  class="duichong-img" src="../../assets/images/ic_duichong.png" alt="" srcset="">
    </div>
    <!-- 关联运营报告 传世任务包 -->
    <div class="contract-base-box" v-show="formData.platformTaskGuid || formData.operationReportGuid">
      <div class="back-color-fff mt-4" >
        <el-row v-show="formData.operationReportGuid" style="padding-top:20px" :gutter="24">
            <el-col :span="24" class="base-box">
                <span class="label">关联运营报告：</span>
                <div class="file-img-box">
                    <span>{{ formData.relevance || '-' }}</span>
                    <a  class="file-preview" @click="see(formData.filePath)">查看详情</a>
                </div>
            </el-col>
        </el-row>
        <el-row v-show="formData.platformTaskGuid && taskTitle" :gutter="24">
            <el-col :span="24" class="base-box">
                <span class="label">传世任务包：</span>
                <div class="file-img-box">
                    <span>{{ taskTitle || '-' }}</span>
                    <a  class="file-preview" @click="seeCsTask(formData.filePath)">查看详情</a>
                    <a  v-if="reportFile"  class="file-preview" @click="onPreview(reportFile)">运营报告查看</a>
                </div>
            </el-col>
        </el-row>
      </div>
    </div>
    <!-- 信息 -->
    <div class="back-color-fff">
      <TabList :tabList="tabList" :tabIndex="tabIndex" @tabChange="tabChange" marginTop="4px"></TabList>
    </div>
    <div class="back-color-fff content-main-box h100f" style="padding: 0 16px" v-show="currentTabIndex == 0">
      <div style="display: flex; justify-content: space-between; align-items: center">
        <div class="button-area fl pl0">
          <el-button size="mini" type="borderGreen" @click="exportTable(1)">导出</el-button>
          <el-button size="mini" v-if="formData.approveState == 'N' || formData.approveState == 'Y'" type="borderGreen" @click="recalculate(1)">重算任务大类</el-button>
        </div>
        <p class="total-tip">
          平台考核后金额合计：<span>{{ getSumAmount(tableOneList, 1) | numDigit }}</span
          >元&nbsp;&nbsp;&nbsp;应发金额合计：<span>{{ getSumAmount(tableOneList, 2) | numDigit }}</span>
          元&nbsp;&nbsp;&nbsp;实发金额合计：<span>{{ getSumAmount(tableOneList, 4) | numDigit }}</span>
          元&nbsp;&nbsp;&nbsp;任务完成金额合计：<span>{{ getSumAmount(tableOneList, 3) | numDigit }}</span> 元
        </p>
      </div>
      <el-table
        :data="tableOneList"
        ref="tableOne"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        :height="tableOneList.length >= 10 ? 360 : ''"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column label="序号" fixed="left" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="姓名" fixed="left" width="96" header-align="center" align="center">
          <template slot-scope="scope">
            {{ scope.row.staffName }}
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in fieldData"
          :key="index"
          :prop="item.fieldName"
          :label="item.title"
          show-overflow-tooltip
          header-align="center"
          :align="item.align"
          :width="item.width"
        >
          <template slot-scope="scope">
            <span v-if="item.type == 'orderNum'">{{ scope.$index + 1 }}</span>
            <span v-if="item.type == 'score'">{{ Number(scope.row[item.fieldName]).toFixed(6) }}</span>
            <span v-if="item.type == 'amount' && item.fieldName !== 'cutTotalMoney'">{{
              scope.row[item.fieldName] | numDigit
            }}</span>
            <span v-if="item.type == 'amount' && item.fieldName == 'cutTotalMoney'">{{
               scope.row[item.fieldName]  | numDigit
            }}</span>
            <span v-if="item.type == 'text'">{{ scope.row[item.fieldName] || '-' }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 表格 -->
    <div class="back-color-fff content-main-box h100f" style="padding: 0 16px" v-show="currentTabIndex == 1">
      <div class="button-area fl pl0">
        <el-button size="mini" type="borderGreen" @click="exportTable()">导出</el-button>
      </div>
      <el-table
        :data="tableTwoList"
        stripe
        border
        row-key="guid"
        default-expand-all
        :tree-props="{ children: 'taskDetailList' }"
        ref="tableTwo"
        header-cell-class-name="table_header"
        max-height="500px"
      >
        <el-table-column
          prop="staffName"
          label="推广服务人员"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="120"
        >
          <template slot-scope="scope">{{ scope.row.staffName || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="taskContentName"
          label="任务内容"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="120"
        >
          <template slot-scope="scope">{{ scope.row.taskContentName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="rate" label="占比" show-overflow-tooltip header-align="center" align="right" width="100">
          <template slot-scope="scope">{{ scope.row.rate || '-' }}</template>
        </el-table-column>
        <el-table-column
          sortable
          prop="taskMoney"
          label="实际完成金额(元)"
          show-overflow-tooltip
          header-align="center"
          align="right"
          width="160"
        >
          <template slot-scope="scope">{{ scope.row.taskMoney | numDigit }}</template>
        </el-table-column>
        <el-table-column
          sortable
          prop="realMoney"
          label="结算金额(元)"
          show-overflow-tooltip
          header-align="center"
          align="right"
          width="160"
        >
          <template slot-scope="scope">{{ scope.row.realMoney | numDigit }}</template>
        </el-table-column>
        <el-table-column
          sortable
          prop="isOverMoney"
          label="是否超额结算"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="120"
        >
          <template slot-scope="scope"
            ><span :style="scope.row.isOverMoney == '超额结算' ? 'color:red' : ''">{{
              scope.row.isOverMoney || '-'
            }}</span></template
          >
        </el-table-column>
      </el-table>
      <!-- 简述备注 -->
      <div v-show="currentTabIndex == 1" class="remark">
        <p style="text-align: left">{{ '简述或备注' }}</p>
        <el-input
          disabled
          type="textarea"
          :rows="2"
          v-model="formData.remark"
          placeholder="请输入, 限制100个字"
          maxlength="100"
          show-word-limit
          clearable
        >
        </el-input>
      </div>
      <div></div>
    </div>
    <!-- 流程 -->
    <div style="padding-left: 16px; background: #fff; margin-top: 4px">
      <iframe v-show="iframeSh" :src="srcs" class="iframe-sty"></iframe>
    </div>
    <!-- 提交 -->
    <div class="submit_btn_wrap" v-if="formData">
      <el-button type="borderBlack" size="small" @click="$router.go(-1)">取消</el-button>
      <el-button type="borderRed" size="small" v-show="getBtnState('approval') == 'approval'" @click="toReject"
        >驳回</el-button
      >
      <el-button type="importNew" size="small" v-show="getBtnState('approval') == 'approval'" @click="toPass"
        >通过</el-button
      >
      <!-- <el-button type="importNew" size="small" v-show="getBtnState('again') == 'again'" @click="reSubmit"
        >重新提交</el-button
      > -->
      <el-button type="importNew" size="small" v-show="getBtnState('revoke') == 'revoke'" @click="toRevoke"
        >撤销</el-button
      >
    </div>
    <el-dialog title="驳回流程" :visible.sync="rejectDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="输入驳回理由（必填）" v-model="approveSuggest" maxlength="100">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toRejectSubmit()">驳回</el-button>
      </span>
    </el-dialog>
    <el-dialog title="通过流程" :visible.sync="passDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="输入通过备注（非必填）" v-model="approveSuggest" maxlength="100">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toPassSubmit()">通过</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { bpmnroute } from '@/api/apiRoute';
import Title from '@/components/title/title.vue';
import workFlowCommon from '@/uilt/workFlowCommon';
import { onPreview } from '@/uilt/tool';
import TabList from '@/components/tab/tabList.vue';
export default {
  components: {
    Title,
    TabList,
  },
  data() {
    return {
      onPreview:onPreview,
      selectData: [],
      flowType: '00020',
      tabList: [{ tabName: '考核一览表' }, { tabName: '任务完成明细' }],
      currentTabIndex: 0, //当前tab
      tabIndex: 0,
      tableOneList: [],
      tableTwoList: [],
      fullscreenLoading: false,
      rejectDialogVisible: false,
      passDialogVisible: false,
      taskDialogVisible: false,
      approveSuggest: '',
      formData: {},
      contractFileName: '',
      currentOrganisationName: '',
      taskData: [],
      //需验证的字段合集
      fieldData: [
        // { width:'60',title: '序号', fieldName: 'orderNum', type: 'orderNum',align:'center'},
        // { width:'96',title: '姓名', fieldName: 'staffName', type: 'text',align:'left' },
        { width: '140', title: '平台组织名称', fieldName: 'organisationName', type: 'text', align: 'left' },
        { width: '140', title: '平台岗位名称', fieldName: 'positionList', type: 'text', align: 'left' },
        { width: '140', title: '平台考核后金额(元)', fieldName: 'finishMoney', type: 'amount', align: 'right' },
        { width: '140', title: '应发金额(元)', fieldName: 'realMoney', type: 'amount', align: 'right' },
        { width: '140', title: '实发金额(元)', fieldName: 'payMoney', type: 'amount', align: 'right' },
        { width: '140', title: '任务完成金额(元)', fieldName: 'taskSalary', type: 'amount', align: 'right' },
        { width: '140', title: '扣奖总额(元)', fieldName: 'cutTotalMoney', type: 'amount', align: 'right' },
        { width: '140', title: '管控总评', fieldName: 'totalManageScore', type: 'score', align: 'right' },
        { width: '140', title: '下发平台', fieldName: 'levyCompanyName', type: 'text', align: 'left' },
        { width: '140', title: '时间管理', fieldName: 'timeManageScore', type: 'score', align: 'right' },
        { width: '140', title: '质量管理', fieldName: 'qualityManageScore', type: 'score', align: 'right' },
        { width: '140', title: '客户管理', fieldName: 'customerManageScore', type: 'score', align: 'right' },
        { width: '140', title: '计划管理', fieldName: 'planManageScore', type: 'score', align: 'right' },
        { width: '140', title: '使用频度', fieldName: 'useCountScore', type: 'score', align: 'right' },
        
        { width: '140', title: '调整意见', fieldName: 'adjustmentOpinions', type: 'text', align: 'left' },
        { width: '140', title: '留存金额(元)', fieldName: 'lastMonthLeftMoney', type: 'amount', align: 'right' },
      ],
      //流程
      srcs: '',
      processInstanceId: '',
      iframeSh: true,
      currentStaffGuid: null, //当前登录人guid
      pageTable: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
      },
      actualAmount: 0, //合计实际金额
      settlementAmount: 0, //合计结算金额
      platform: {}
    };
  },
  filters: {
    categoryType(val) {
      let objStr = {
        1: '否',
        2: '是',
      };
      return objStr[val] || '-';
    },
    billFilter(list) {
      let str='-'
      if(list&&list.length>0){
        str=list.join('、')
      }
      return str
    }
  },
  watch:{
    // 平台专属任务
    "formData.taskBelongCategory":{
      immediate:true,
      handler(val){
        this.formData.tenantGuid=null
        if(val==2){
          this.tabList= [{ tabName: '考核一览表' }]
        }else {
          this.tabList=[{ tabName: '考核一览表' }, { tabName: '任务完成明细' }]
        }
       
    }},
  },
  computed: {
    taskTitle() {
      return this.platform ? `${this.getName(this.platform.taskCategory, '任务类别')}${this.$moment(this.platform.startTime).format('YYYY.MM.DD')}-${this.$moment(this.platform.endTime).format('YYYY.MM.DD')}` : ''
    },
    reportFile() {
      return Array.isArray(this.platform.reportFileList) &&  this.platform.reportFileList.length ? this.platform.reportFileList[0] : null
    }
  },
  created() {
    let userinfo = JSON.parse(localStorage.userInfo);
    this.currentStaffGuid = userinfo.staffGuid;
    this.currentOrganisationName = userinfo.organisationName;
    this.getPageDetail();
    // this.getBpmnUrl();放到getPageDetail回调里面了
  },
  methods: {
    getSumAmount(list, type) {
      let sum = 0;
      if (type == 1) {
        list.forEach((item) => {
          sum += Math.round(item.finishMoney * 100) / 100 ;
        });
      }
      if (type == 2) {
        list.forEach((item) => {
        //  sum += item.realMoney;
          sum += Math.round(item.realMoney * 100) / 100 ;
        });
      }
      if (type == 3) {
        list.forEach((item) => {
          sum += Math.round(item.taskSalary * 100) / 100 ;
          //sum += item.taskSalary;
        });
      }
      if(type==4){
        list.forEach(item => {
          sum += Math.round(item.payMoney * 100) / 100 ;
         // sum += item.payMoney;
        })
      }
      return sum;
    },
    //状态图片
    getApproveImg() {
      return workFlowCommon.getApproveImg(this.formData.approveState);
    },
    //获取操作按钮显隐
    getBtnState(btnType) {
      return workFlowCommon.getBtnState(
        btnType,
        this.formData.approveState,
        this.formData.approveStaffGuids,
        this.currentStaffGuid,
        this.formData.staffGuid, //提交人id
        this.formData.bizApproveState,
      );
    },
    // 显示表格选中任务数量展示 任务1 + n
    getTaskName(list) {
      let name = '-';
      if (list && list.length == 1) {
        name = list[0].taskContentName;
      }
      if (list && list.length > 1) {
        name = list[0].taskContentName + '等' + list.length + '个任务';
      }
      return name;
    },
    getSum(tree, idx, sums, index) {
      if (tree && tree.length > 0) {
        tree.map((item) => {
          this.getSum(item.taskDetailList, idx, sums, index);
          sums[index] += Number(item[idx]);
        });
      }
    },
    /**
         * 关联流程，查看详情
         */
   
    see() {
            let self = this;
            self.fullscreenLoading = true;
            self.api
                .get(
                    `/${serverConfig.msSalesPerformService}/upstream/operation-report/detail?guid=${this.formData.operationReportGuid}`,
                )
                .then((res) => {
                    self.fullscreenLoading = false;
                    if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                        let data = res.data.data;
                        this.$router.push({
                            path: '/upstreamOperationReportDetail',
                            query: {
                                productGuid: this.$route.query.productGuid,
                                guid: this.formData.operationReportGuid,
                                approveStaffGuid: data.approveVO.approveGuid,
                                camundaInstanceId: data.approveVO.camundaInstanceId,
                                camundaDeploymentId: data.approveVO.camundaDeploymentId,
                                tenantGuid: data.tenantGuid,
                                submitStaffGuid: data.approveVO.staffGuid,
                                submitStaffName: data.approveVO.staffName,
                                toType: 2,
                            }
                        })
                    } else {
                        self.$message.error(res.data.msg);
                    }
                })
                .catch(() => {
                    self.fullscreenLoading = false;
                });
    },
    // 查看传世任务详情
    seeCsTask() {
      let param = {
        guid: this.formData.platformTaskGuid,
        productGuid: this.$route.query.productGuid,
      }
      this.$router.push(`/platformTaskEdit?guid=${param.guid}&productGuid=${param.productGuid}&is_detail=1`)
    },       
    formatMoney(num) {
      // 将数字转换为字符串并保留两位小数
      num = num.toFixed(2);

      // 将字符串按小数点分割成整数部分和小数部分
      var parts = num.toString().split(".");

      // 将整数部分每三位加一个逗号
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      // 将整数部分和小数部分拼接起来
      return parts.join(".");
    },
    //获取运营报告详情
    getDetail() {
      let self = this;
      if(!this.formData.operationReportGuid) return
      self.api
        .get(`/${serverConfig.msSalesPerformService}/upstream/operation-report/detail?guid=${this.formData.operationReportGuid}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let data = res.data.data;
            // 运营报告
            this.formData.relevance = data['approveVO']['staffName'] + ' _ ' + data['tenantName'] + ' _ ' + data['accountMonth'] + (data['currentPayAmount'] ? (' _ ' + this.formatMoney(data['currentPayAmount']) + '(元)') : '');
            // 传世任务包
            this.formData.relevance = data['approveVO']['staffName'] + ' _ ' + data['tenantName'] + ' _ ' + data['accountMonth'] + (data['currentPayAmount'] ? (' _ ' + this.formatMoney(data['currentPayAmount']) + '(元)') : '');
            this.formData.billCycleList=data['billCycleList'];
            console.log(data);
            this.$forceUpdate()
            
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        // 初始化合计行
        sums[index] = 0;
        // 递归求和
        this.getSum(data, column.property, sums, index);
        // 如果求和得到的结果是非数字,则显示--
        if (isNaN(sums[index]) || column.property == 'rate') {
          sums[index] = '-';
        }
      });
      return sums;
    },
    //获取详情
    getPageDetail() {
      let self = this;
      self.fullscreenLoading = true;
      self.api
        .get(
          `/${serverConfig.msSalesPerformService}/quality-assessment/data/detail/get-by-guid?guid=${this.$route.query.guid}`,
        )
        .then((res) => {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.formData = res.data.data;
            self.formData.taskGuidList = self.formData.taskGuidList ? JSON.parse(self.formData.taskGuidList) : [];
            self.searchDataOne();
            if(this.formData.taskBelongCategory!=2)self.searchDataTwo();
            if(this.formData.platformTaskGuid)self.getDetailPlatform(this.formData.platformTaskGuid);
            self.getDetail()
            self.getBpmnUrl();
          } else {
            self.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          self.fullscreenLoading = false;
        });
    },
    // 点击tab
    tabChange(item, index) {
      this.currentTabIndex = index;
    },
    //查询数据
    searchDataOne() {
      let self = this;
      self.api
        .get(
          `/${serverConfig.msSalesPerformService}/quality-assessment/data/detail/get-detail-tab1?guid=${this.$route.query.guid}`,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tableOneList = res.data.data || [];
            self.$nextTick(() => {
              //在数据加载完，重新渲染表格
              self.$refs['tableOne'].doLayout();
            });
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    searchDataTwo() {
      let self = this;
      self.api
        .get(
          `/${serverConfig.msSalesPerformService}/quality-assessment/data/detail/get-detail-tab2?guid=${this.$route.query.guid}`,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tableTwoList = res.data.data || [];
            self.actualAmount = 0; //实际金额合计
            self.settlementAmount = 0; //结算金额合计
            self.orginTableTwoList = res.data.data ? JSON.parse(JSON.stringify(res.data.data)) : [];
            if (self.tableTwoList && self.tableTwoList.length > 0) {
              self.tableTwoList.forEach((i) => {
                i.taskContentName = '-';
                i.taskContentGuid = '-';
                i.rate = 0;
                self.actualAmount = self.actualAmount + i.taskMoney;
                self.settlementAmount = self.settlementAmount + i.realMoney;
                if (i.taskDetailList && i.taskDetailList.length > 0) {
                  i.taskDetailList.forEach((j) => {
                    j.staffName = '-';
                    j.staffGuid = null;
                    j.realMoney = '-';
                    j.isOverMoney = '-';
                  });
                }
              });
              let obj = {
                guid: '9999999999999999999',
                isOverMoney: self.settlementAmount > self.actualAmount ? '超额结算' : '未超额结算',
                rate: '-',
                realMoney: self.settlementAmount,
                staffGuid: '-',
                staffName: '合计',
                taskContentGuid: '-',
                taskContentName: '-',
                taskMoney: self.actualAmount,
                taskDetailList: null,
              };
              self.tableTwoList.push(obj);
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //导出1
    exportTable(type) {
      let path =
        type == 1
          ? '/quality-assessment/data/detail/export-tab1?guid='
          : '/quality-assessment/data/detail/export-tab2?guid=';
      this.exportSettingLoading = true;
      this.api.get(`/${serverConfig.msSalesPerformService}${path}${this.formData.guid}`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.reportJx(res.data.data.colNames, res.data.data.datas, res.data.data.sheetName, res.data.data.fileNam);
        } else {
          this.$message.error(res.data.msg);
          this.exportSettingLoading = false;
        }
      });
    },
    // todo重新结算方法
    recalculate() {
      if (!this.selectData.length) {
         this.$message({
          message: '请勾选',
          type: 'warning'
        });
        return;
      }
      let param = {
        serviceTenantGuid: this.formData.serviceTenantGuid,
        guidList:this.selectData.map(item=>item.guid)
      }
      this.api.postJson(`/${serverConfig.msSalesPerformService}/quality-assessment/data/reset-task-type`,param).then(res=>{
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message({
              message: '重算成功',
              type: 'success'
            });
          } else {
            this.$message.error(res.data.msg);
          }
      })
    },
    // todo勾选的钩子
    handleSelectionChange(val) {
      this.selectData = val;
    },
    reportJx(colNames, datas, sheetName, fileNam) {
      let self = this;
      let fileName =
        self.formData.tenantName +
        '_' +
        self.formData.organisationName +
        '_' +
        self.formData.accountMonth +
        '_' +
        (self.formData.isPrecise == 'Y' ? '精准考核' : '非精准考核');
      self.api
        .postJsonD(`/${serverConfig.msCommonAdminCloudService}/excel/export`, {
          colNames: colNames,
          datas: datas,
          sheetName: sheetName,
          fileNam: fileNam,
        })
        .then((res) => {
          self.exportSettingLoading = false;
          self.showExportHead = false;
          let blob = new Blob([res.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });

          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.download = fileName;
          link.href = objectUrl;
          link.click();
        });
    },
    getBpmnUrl() {
      if(this.$route.query.isDownstream){
        this.srcs =
          bpmnroute +
          '/iframeBpmn?processInstanceId=' +
          this.formData.camundaInstanceId +
          '&camundaDeploymentId=' +
          this.formData.camundaDeploymentId +
          '&token=' +
          localStorage.token;
          console.log(this.srcs);
      }else if (this.$route.query.camundaInstanceId && this.$route.query.camundaDeploymentId) {
        this.srcs =
          bpmnroute +
          '/iframeBpmn?processInstanceId=' +
          this.$route.query.camundaInstanceId +
          '&camundaDeploymentId=' +
          this.$route.query.camundaDeploymentId +
          '&token=' +
          localStorage.token;
        console.log(this.srcs);
      } else {
        this.iframeSh = false;
      }
    },
    //撤销
    toRevoke() {
      let self = this;
      self
        .$confirm('确定撤销吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          let query = {
            guid: self.formData.approveGuid,
            flowType: self.flowType,
            approveStaffGuid: self.currentStaffGuid,
          };
          self.fullscreenLoading = true;
          self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/canal-flow`, query).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.fullscreenLoading = false;
              self.$message.success(messageConfig.FLOW_CANCEL);
              sessionStorage.refresh = 1;
              self.$router.go(-1);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          self.$message({
            type: 'info',
            message: '已取消操作！',
          });
        });
    },
    //重新提交
    reSubmit() {
      this.$router.push({
        path: '/contractInformationAdd',
        query: {
          // bizGuid: this.$route.query.bizGuid,
          guid: this.$route.query.guid,
          query: {
            productGuid: this.$route.query.productGuid,
          },
        },
      });
    },
    toPass() {
      let self = this;
      self.approveSuggest = '';
      self.passDialogVisible = true;
    },
    toReject() {
      let self = this;
      self.approveSuggest = '';
      self.rejectDialogVisible = true;
    },
    //通过
    toPassSubmit() {
      let self = this;
      let query = {
        guid: self.formData.approveGuid,
        flowType: self.flowType,
        approveSuggest: self.approveSuggest,
        approveStaffGuid: self.currentStaffGuid,
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`, query).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success(messageConfig.FLOW_PASS);
          sessionStorage.refresh = 1;
          self.$router.go(-1);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //驳回
    toRejectSubmit() {
      let self = this;
      if (self.approveSuggest == '') {
        self.$message.error('请填写驳回理由！');
        return;
      }
      let query = {
        guid: self.formData.approveGuid,
        flowType: self.flowType,
        approveSuggest: self.approveSuggest,
        approveStaffGuid: self.currentStaffGuid,
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`, query).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success(messageConfig.FLOW_REJECT);
          sessionStorage.refresh = 1;
          self.rejectDialogVisible = false;
          self.$router.go(-1);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getName(name, key) {
      if (!name) return '-';
      let list = this.getCodeListByKey(key);
      if (typeof name == 'object') {
        let newArr = [];
        name.forEach(item => {
          list.forEach(el => {
            if (el.value == item) {
              newArr.push(el.text);
            }
          })
        })
        return newArr.length ? newArr.join('、') : '-';

      } else {
        let lisArr = list.filter(item => item.value == name);
        return lisArr.length ? lisArr[0].text : '-';
      }

    },
    getDetailPlatform(guid) {
      let param = {
        guid,
      }
      this.api
        .get(`/${serverConfig.msSalesPerformService}/platform-task/detail`,param)
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.platform = res.data.data;
          }
        })
        .catch(() => {
        });
    },
  },
};
</script>
<style lang="less" scoped>
.contract-information-page {
  overflow: auto;
}
.contract-base-box {
  position: relative;
  padding: 10px 16px;
  margin-top: 4px;
  background: #fff;
  /deep/ .el-row {
      margin-left: 20px !important;
      padding-bottom: 20px;
  }
  
}
.contract-base-name {
  font-size: 16px;
  color: #212121;
  text-align: left;
  margin: 8px 0 20px 0;
}
/* 申请信息 */
.contract-apply-box {
  display: flex;
  padding-left: 10px;
  margin-bottom: 25px;
}
.contract-apply-item {
  font-size: 14px;
  color: #666666;
  padding: 0 20px;
  box-sizing: border-box;
  border-right: 1px solid #e5e5e5;
}
.contract-apply-file {
  display: flex;
  font-size: 14px;
  color: #666666;
  padding: 0 20px;
  box-sizing: border-box;
}
.contract-file-inform {
  display: flex;
  align-items: center;
  margin-bottom: 23px;
}
.approve-img {
  position: absolute;
  top: 50px;
  right: 60px;
  width: 78px;
  height: 78px;
}
/* 合同信息 */
.file-preview {
    margin-left: 10px;
    cursor: pointer;
    text-decoration: underline;
    cursor: pointer;
    color: #4fa1a4;
    word-break: keep-all;
}
.base-box {
  display: flex;
  align-items: center;

  .label {
      font-size: 14px;
      color: #666666;
      width: 100px;
      text-align: right;
  }
}
.form-box {
  margin-top: 4px;
  text-align: left;


  

  

  .base-box {
      display: flex;
      align-items: center;

      .label {
          font-size: 14px;
          color: #666666;
          width: 100px;
          text-align: right;
      }
  }

  .bottom-btn-box {
      padding: 18px 0px;
      text-align: center;
      border-top: 1px solid #E5E5E5;

      .el-button--primary {
          color: #ffffff;
      }
  }
}
.file-img-box {
    display: flex;
    align-items: center;

    img {
        width: 26px;
        height: 26px;
        margin-right: 10px;
    }

    .see-btn {
        font-size: 14px;
        color: #4FA1A4;
        letter-spacing: 0;
        line-height: 21px;
        font-weight: 400;
        cursor: pointer;
        margin-left: 10px;
    }
}

.contract-base-box .el-col-12 {
  display: flex;
  line-height: 22px;
  margin-bottom: 20px;
  
}
.el-col-12:nth-child(2n + 1) .contract-base-title {
  flex-shrink: 0;
  width: 100px;
  text-align: right;
  font-size: 14px;
  color: #666666;
}
.el-col-12:nth-child(2n) .contract-base-title {
  flex-shrink: 0;
  width: 140px;
  text-align: right;
  font-size: 14px;
  color: #666666;
}
.contract-base-content {
  color: #212121;
  text-align: left;
}
/* 流程 */
.iframe-sty {
  width: 100%;
  height: 500px;
  border: none;
  /* background:grey; */
}
.select-task {
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
}
.plan-detail {
  display: flex;
  justify-content: space-between;
}
.remark {
  background-color: #fff;
  padding-bottom: 8px;
  width: 780px;
}
.remark p {
  margin: 8px 0;
}
.total-tip span {
  color: #ff5f1f;
}
.duichong-img{
  position:absolute;
  top:0;
  right:0;
  width:81px;
}
</style>
